import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../util/Utils";

export function UseComment() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  function validate(state, imgState, setter) {
    let errorState = {
      title: isEmpty(state.title),
      url: isEmpty(state.url),
      file1: isEmpty(imgState.url1),
      file2: isEmpty(imgState.url2),
    };

    setter(errorState);

    if (errorState.title || errorState.url) {
      enqueueSnackbar("لطفا اطلاعات اسلاید را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const MyNewComments = (pageNumber, bool, callback) => {
    let myPC = { Page: pageNumber };
    MyAxios.get(`Admin_Comments/1`, {
      headers: {
        IsPage: bool ? true : false,
        Conditions: JSON.stringify(myPC),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const MyProductComments = (pageNumber, callback) => {
    let myPC = { Page: pageNumber };
    MyAxios.get(`Admin_Comments/2`, {
      headers: {
        Conditions: JSON.stringify(myPC),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const ProductComments = (
    pageNumber,
    Mobile,
    ProductID,
    ArticleID,
    CommentID,
    callback
  ) => {
    let myPC = {
      Page: pageNumber,
      Mobile: Mobile,
      ProductID: ProductID,
      ArticleID: ArticleID,
      CommentID: CommentID,
    };

    let newBody = Object.fromEntries(
      Object.entries(myPC).filter(([_, v]) => v != "")
    );
    MyAxios.get(`Admin_Comments/3`, {
      headers: {
        Conditions: JSON.stringify(newBody),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const GetCommentByID = (CommentID, callback) => {
    MyAxios.get(`Admin_Comments/ByID/${CommentID}`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };
  const GetUserProfile = (Profile, callback) => {
    MyAxios.get(`Admin_Users/Profile/${Profile}`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const submitComment = (Model, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(Model));
    MyAxios.post(`Admin_Comments`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar(" باموفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  const UpdateComment = (Model, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(Model));
    MyAxios.put(`Admin_Comments`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("ویرایش کامنت باموفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  const DeleteComment = (CommentID, callback) => {
    const data = new FormData();
    data.append("CommentID", CommentID);
    MyAxios.delete(`Admin_Comments`, { data: data }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("حذف کامنت باموفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  const GetOperators = (callback) => {
    MyAxios.get(`Admin_Comments/Operators`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const GetSigns = (callback) => {
    MyAxios.get(`Admin_Comments/Signs`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const GetMessages = (callback) => {
    MyAxios.get(`Admin_Comments/Messages`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const ChangeOperator = (Model, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(Model));
    MyAxios.post(`Admin_Comments/ChangeOperator`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("انتقال کامنت باموفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  const getOrders = (search, callback) => {
    MyAxios.get(`Admin_Orders/7/0?w=${search}`, {
      headers: {
        IsPage: false,
        Conditions: JSON.stringify({
          pageCondition: {
            page: 1,
            pageCount: 1,
            sortColumn: "Id",
            sortOrder: "Desc",
          },
        }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  return {
    MyNewComments,
    MyProductComments,
    ProductComments,
    GetCommentByID,
    GetOperators,
    validate,
    submitComment,
    UpdateComment,
    DeleteComment,
    GetSigns,
    GetMessages,
    ChangeOperator,
    GetUserProfile,
    getOrders,
  };
}
